// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            applyTravel: false,
            type: actions.UPDATE_CLAIM_NORMAL_APPLY_TRAVEL
        });

        dispatch({
            type: actions.UPDATE_CLAIM_NORMAL_UPDATE_SHOW_APPLY_TRAVEL,
            updateShowApplyTravel: false
        });

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_NORMAL
        });

        dispatch(routerActions.replace('/claims/normal/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/copy-claim.js